import { SxProps, Theme } from '@mui/material';

const label: SxProps<Theme> = {
  color: 'customGrey.dark',
  marginLeft: 0,
  '& > .MuiTypography-root': { marginLeft: '8px' }
};

const checkbox: SxProps<Theme> = {
  padding: 0,
  width: '25px',
  height: '25px'
};

export const teamCheckboxGroupSx = {
  label,
  checkbox
};
